import { Injectable } from '@angular/core';

/* Preserves the Number Ones register view state across plate-detail
   navigation so the browser Back button returns the visitor to where they
   were (the app's router uses scrollPositionRestoration:'top', so scroll is
   restored manually by the page). Session-scoped, in-memory only. */
export interface NumberOnesSnapshot {
  arr: 1 | 2;
  view: 'catalogue' | 'matrix';
  avail: 'all' | 'available' | 'held';
  catLetter?: string;
  fieldTerm: string;
  scrollY: number;
  savedAt: number;
}

@Injectable({ providedIn: 'root' })
export class NumberOnesStateService {
  public snapshot: NumberOnesSnapshot | null = null;

  /* Restore only for a plausible back-navigation window. */
  public takeFresh(maxAgeMs: number = 30 * 60 * 1000): NumberOnesSnapshot | null {
    const s = this.snapshot;
    if (!s || Date.now() - s.savedAt > maxAgeMs) return null;
    return s;
  }
}
